import { useState } from "react";
import { withTranslation } from "react-i18next";

import Radio from "@krea/customer-features/shared-components/fields/radio";
import RadioGroup from "@krea/customer-features/shared-components/fields/radiogroup";
import { usePostFieldRequest } from "@krea/customer-features/store/field-requests/hooks/mutations";
import { useGetOneFieldRequest } from "@krea/customer-features/store/field-requests/hooks/queries";

import FieldRequestPreviewHeader from "../FieldRequestPreviewHeader";
import FieldRequestSaved from "../FieldRequestSaved";

const PropertyOwnerForm = ({ fieldRequestID, isPreviewMode, t }) => {
  const { data: { displayName, submittedData } = {} } =
    useGetOneFieldRequest(fieldRequestID);
  const { mutate: postFieldRequest } = usePostFieldRequest(fieldRequestID);

  const [isPropertyOwner, setIsPropertyOwner] = useState(
    submittedData?.is_property_owner?.toString() || "",
  );

  const onChange = ({ target }) => {
    const value = target.value;
    const touched = isPropertyOwner !== value;

    setIsPropertyOwner(value);

    if (touched) {
      postFieldRequest({ is_property_owner: value });
    }
  };

  function mapValueToTranslation(value, t) {
    return {
      true: t("iaq.propertyOwner.yes"),
      false: t("iaq.propertyOwner.no"),
    }[value.toLowerCase()];
  }

  return (
    <>
      {isPreviewMode ? (
        <>
          <FieldRequestPreviewHeader
            label={displayName}
            value={mapValueToTranslation(isPropertyOwner, t)}
          />
        </>
      ) : (
        <>
          <RadioGroup value={isPropertyOwner} onChange={onChange}>
            <Radio
              value="true"
              checked={isPropertyOwner === "true"}
              label={t("iaq.propertyOwner.yes")}
            />
            <Radio
              value="false"
              checked={isPropertyOwner === "false"}
              label={t("iaq.propertyOwner.no")}
            />
          </RadioGroup>

          <FieldRequestSaved fieldRequestID={fieldRequestID} />
        </>
      )}
    </>
  );
};

export default withTranslation()(PropertyOwnerForm);
